module.exports = __webpack_public_path__ + "img/h2.fe317f69.svg";